import React, { useEffect, useState } from 'react';

import { TextAreaField } from './edit_blocks';
import '../css/requirements.css';

const fields = [
    {
        name: 'cpu',
        label: 'ЦП',
    },
    {
        name: 'ram',
        label: 'Оперативная память',
    },
    {
        name: 'gpu',
        label: 'Видеокарта',
    },
    {
        name: 'hdd',
        label: 'Место на диске',
    },
];

export default function RequirementsBlock({ systemRequirements, reqFallback, onChange }) {
    const [isText, setText] = useState(false);
    const [values, setValues] = useState({
        min: {
            cpu: (systemRequirements && systemRequirements.min && systemRequirements.min.cpu) || '',
            ram: (systemRequirements && systemRequirements.min && systemRequirements.min.ram) || '',
            gpu: (systemRequirements && systemRequirements.min && systemRequirements.min.gpu) || '',
            hdd: (systemRequirements && systemRequirements.min && systemRequirements.min.hdd) || '',
        },
        rec: {
            cpu: (systemRequirements && systemRequirements.rec && systemRequirements.rec.cpu) || '',
            ram: (systemRequirements && systemRequirements.rec && systemRequirements.rec.ram) || '',
            gpu: (systemRequirements && systemRequirements.rec && systemRequirements.rec.gpu) || '',
            hdd: (systemRequirements && systemRequirements.rec && systemRequirements.rec.hdd) || '',
        },
    });

    useEffect(() => {
        const clonedValues = JSON.parse(JSON.stringify(values));
        // удаляем пустые поля из min
        Object.keys(clonedValues.min).forEach((key) => (!clonedValues.min[key] || !clonedValues.min[key].length) && delete clonedValues.min[key]);
        // удаляем пустые поля из rec
        Object.keys(clonedValues.rec).forEach((key) => (!clonedValues.rec[key] || !clonedValues.rec[key].length) && delete clonedValues.rec[key]);
        // удаляем пустые поля из values
        Object.keys(clonedValues).forEach((key) => (!clonedValues[key] || !Object.keys(clonedValues[key]).length) && delete clonedValues[key]);

        onChange({
            currentTarget: {
                id: 'system_requirements',
                value: JSON.stringify(clonedValues),
            },
        });
    }, [values]);

    function handleSwitch() {
        setText(!isText);
    }

    function handleChange(e) {
        const { id, value, dataset } = e.currentTarget;
        const { type } = dataset;

        setValues({
            ...values,
            [type]: {
                ...values[type],
                [id]: value,
            },
        });
    }

    return (
        <div className="requirements">
            <div className="requirements__heading">
                <p className="requirements__title">Системные требования</p>
                <button onClick={handleSwitch} className="requirements__switch">{isText ? 'поля' : 'текст'}</button>
            </div>
            {isText ? (
                <>
                    <TextAreaField
                        name="sys_req"
                        label="Минимальные"
                        value={reqFallback.min || ''}
                        onChange={onChange}
                        rows={2}
                    />
                    <TextAreaField
                        name="rec_sys_req"
                        label="Рекомендуемые"
                        value={reqFallback.rec || ''}
                        onChange={onChange}
                        rows={2}
                    />
                </>
            ) : (
                <div className="requirements__container">
                    <div className="requirements__column">
                        <p className="requirements__subtitle">Минимальные</p>
                        {fields.map((field) => (
                            <TextAreaField
                                key={field.name}
                                data-type="min"
                                name={field.name}
                                label={field.label}
                                value={values.min[field.name]}
                                onChange={handleChange}
                                rows={2}
                            />
                        ))}
                    </div>
                    <div className="requirements__column">
                        <p className="requirements__subtitle">Рекомендуемые</p>
                        {fields.map((field) => (
                            <TextAreaField
                                data-type="rec"
                                key={field.name}
                                name={field.name}
                                label={field.label}
                                value={values.rec[field.name]}
                                onChange={handleChange}
                                rows={2}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
